// src/components/brands/BrandTable.js
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { useCarContext } from '../components/Context/CarContext';
import EditDialogBodyType from './EditDialog/EditDialogBodyType';
import ConfirmDialog from '../views/ConfirmDialog';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AppBar from '@mui/material/AppBar';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';


const BodyTable = ({ body }) => {
    const { editBody, DeleteBodyType, editOpen, setEditOpen, editType, UpdateBody, currentEditData } = useCarContext();
  console.log(body)
  const [open, setOpen] = useState(false);
  const [selectedBodyId, setSelectedBodyId] = useState(null); // Store the ID of the brand to delete

  const handleDeleteClick = (id) => {
    setSelectedBodyId(id); // Set the brand ID to delete
    setOpen(true); // Open the confirmation dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the confirmation dialog
    setSelectedBodyId(null); // Clear the selected brand ID
  };

  const handleConfirm = () => {
    if (selectedBodyId) {
      DeleteBodyType(selectedBodyId); // Delete the selected brand
    }
    setOpen(false); // Close the confirmation dialog
    };
    // Handle Save from Edit Dialog
    const handleSaveEditBodyType = (updatedData) => {
       
            /* setUpdated(updatedData)*/
        UpdateBody(updatedData)

      

    };
    const columns = [
      { 
        field: 'link', 
        headerName: 'Link', 
        width: 50, 
        renderCell: (params) => ( 
        <i className="bi bi-info-circle"></i> 
        ), 
      },
      { 
        field: 'name', 
        headerName: 'Body Type',
         width: 150, 
      },
      { 
        field: 'action', 
        headerName: 'Action', 
        width: 150, 
        renderCell: (params) => ( 
        <div> 
          <IconButton color="primary" onClick={() => editBody(params.row)} > 
            <Edit /> 
          </IconButton> 
          <IconButton color="secondary" onClick={() => handleDeleteClick(params.row.id)} > 
            <Delete /> 
          </IconButton> 
        </div> ), 
      },

      
     ]; 
     const CustomToolbar = () => ( 
      <GridToolbarContainer> 
        <GridToolbar /> 
      </GridToolbarContainer> 
      );
 function EditToolbar(props) {
     const { setRows, setRowModesModel } = props;
 }
    return(

      <section className="section">
    <div className="row">
      <div className="col-lg-12">
            <div className="card">
                <div className="card-body">
                  <h5 className="card-title"></h5>
                    {/* Tabs */}
                    <Box sx={{ width: '100%' }}>
                        <AppBar position="static" color="default">
                            {/* AppBar content can go here */}
                        </AppBar>
                    </Box>
                    <div style={{ height: '100%', width: '100%' }}>
                        <DataGrid
                         rows={body}
                         columns={columns}
                         slots={{ toolbar: CustomToolbar }}
                         components={{ Toolbar: GridToolbar }}
                      />
                        <ConfirmDialog
                         open={open}
                         onClose={handleClose}
                         onConfirm={handleConfirm}
                         title="Confirm Deletion"
                         content="Are you sure you want to delete this brand?"
                      />
                  {/* EditDialogBrand for Editing */}
                  <EditDialogBodyType
                        open={editOpen}
                        handleClose={() => setEditOpen(false)}
                        type={editType}
                        currentData={currentEditData}
                        handleSave={handleSaveEditBodyType}
                  />
                    </div>
                </div>
            </div>
        </div></div>
</section>
);

  // return (
  //               <TableContainer component={Paper}>
  //                 <Table aria-label="brands table">
  //                   <TableHead>
  //                     <TableRow>
  //                       <TableCell><strong>Body Type</strong></TableCell>
  //                       <TableCell align="right"><strong>Actions</strong></TableCell>
  //                     </TableRow>
  //                   </TableHead>
  //                   <TableBody>
  //               {body.length === 0 ? (
  //                       <TableRow>
  //                         <TableCell colSpan={2} align="center">
  //                           <Typography variant="body1">No brands available.</Typography>
  //                         </TableCell>
  //                       </TableRow>
  //                     ) : (
  //                       body.map((item) => (
  //                         <TableRow key={item.id}>
  //                           <TableCell>{item.name}</TableCell>
  //                           <TableCell align="right">
  //                             <IconButton color="primary" onClick={() => editBody(item)}>
  //                               <Edit />
  //                             </IconButton>
  //                             <IconButton color="secondary" onClick={() => handleDeleteClick(item.id)}>
  //                               <Delete />
  //                             </IconButton>
  //                           </TableCell>
  //                         </TableRow>
  //                       ))
  //                     )}
  //                   </TableBody>
  //               </Table>

                
  //               <ConfirmDialog
  //                 open={open}
  //                 onClose={handleClose}
  //                 onConfirm={handleConfirm}
  //                 title="Confirm Deletion"
  //                 content="Are you sure you want to delete this bodytype?"
  //                     />
  //                     <EditDialogBodyType
  //                         open={editOpen}
  //                         handleClose={() => setEditOpen(false)}
  //                         type={editType}
  //                         currentData={currentEditData}
                          
  //                         handleSave={handleSaveEditBodyType}
  //                     />
  //             </TableContainer>
  //             );
        };

export default BodyTable;
